<title class='greeting_info_a11y_page_header' tabindex='-1'>
  {{ confirmsContent.seoBrowserTitle }}
</title>
<ss-lib-page-layout>
  <div inner>
    <div class='target-offer'></div>
    <div>
      <gyd-secondary-nav-widget active-item="ActivityTab" ></gyd-secondary-nav-widget>
      <div class="target-web-offer"></div>
      <div class='row'>
        <div class='col-12 col-md-9'>
          <app-tetriary-navigation [options]='tetriaryNavigationOptions' activeLink='CONFIRMATIONS'>
          </app-tetriary-navigation>
        </div>
        <div class="col-12 col-md-3 justify-content-md-end d-flex" data-testid="tertiary-nav">
          <div class="tertiary-nav__customize_account">
            <a c11n-link [attr.href]="downloadLinkUrl" data-testid="download-center-link" variant="secondary-independent"
               fontWeight="normal" [attr.aria-label]="'Download center account information'">
              <span class="c11n-link__text">{{ downloadLinkLabel }}</span>
            </a>
          </div>
        </div>
      </div>
    </div>
    <div class='row'>
      <div class='col'>
        <c11n-banner *ngIf='shouldShowErrorBanner' [size]='errorBannerConfig.size' [headingText]='errorBannerConfig.heading'
          [hasCloseControl]='errorBannerConfig.closable'
          [variant]='errorBannerConfig.type'>
          <div class='c11n-text-md--crop'>{{errorBannerConfig.body}}</div>
        </c11n-banner>
      </div>
    </div>

    <div class='main-div'>
      <div class='container-fluid p-0'>
        <div class='header-div mt-3'>
          <div class='row'>
            <div class='col-6 col-sm-9 c11n-grid-story__cell'>
              <h1 class='sub-heading'>{{ confirmsContent.heading }}</h1>
              <div class='row mt-2 desktop-description-view'>
                <span class='confirmations-are-av' [innerHTML]='confirmsContent.confirmsDescription'></span>
              </div>
            </div>
            <div class='col-6 col-sm-3  c11n-grid-story__cell view-select-wrapper mt-3 mt-md-0 desktop-view'>
              <div class='view-select-div float-right-class select-view-dropdown-width'>
                <label id='selectId-description' style='display: none;'>select view</label>
                <c11n-dropdown [menuData]='dropdownMenuOptions' labelText='' (stateChange)='viewRedirect($event)'
                               [placeholderText]="confirmsContent.viewDropdownPlaceholder || 'Select view'" variant='basic' class='selectViewDropdown'
                               aria-label='select view' [labelText]="confirmsContent.viewDropdownLabel || 'View:'"></c11n-dropdown>
              </div>
            </div>
            <div class='col-6 col-sm-3 c11n-grid-story__cell view-select-wrapper mt-md-0 mobile-view'>
              <label id='selectId-description-overflow' style='display: none;'>select view</label>
              <label class='view-text'>View</label>
              <c11n-nav-overflow [menuData]='dropdownMenuOptions' labelText=''
                                 (selectItemEvent)='viewRedirectOverflow($event)'
                                 placeholderText='Select view' variant='basic' class='selectViewDropdown'
                                 aria-label='select view' text="View"></c11n-nav-overflow>
            </div>
          </div>
          <div class='row mobile-description-view'>
            <div class="col-12">
              <span class='confirmations-are-av' [innerHTML]='confirmsContent.confirmsDescription'></span>
            </div>
          </div>
        </div>

        <div class='row mt-3'>
          <div class='col-12 c11n-grid-story__cell filter-div custom-frame-size custom-frame-size'>
            <div class='d-inline-block me-4 col-12 col-lg-2 col-md-2 col-sm-12 c11n-grid-story__cell custom-container'>
              <c11n-select label='' hintText='' labelText='' class='hide-select-label-and-error'
                           (change)="getSelectedValue($event, 'YEAR')" [labelText]="confirmsContent.formFields.yearLabel || 'Year'">
                <select c11nSelectInput id='select-year-id' class='c11n-select__box__select' [attr.aria-label]="confirmsContent.formFields.yearAltText || 'select year'"
                        [(ngModel)]='selectedValues.year'>
                  <option *ngFor='let y of years; let i = index' [value]='y'>{{ y }}</option>
                </select>
              </c11n-select>
            </div>

            <div class='d-inline-block me-4 col-12 col-lg-2 col-md-3 c11n-grid-story__cell custom-container'>
              <c11n-select label='' hintText='' labelText='' class='hide-select-label-and-error'
                           (change)="getSelectedValue($event, 'MONTH')" [labelText]="confirmsContent.formFields.monthsLabel || 'Months'">
                <select c11nSelectInput id='select-month-id' class='c11n-select__box__select' [attr.aria-label]="confirmsContent.formFields.monthsAltText || 'select month'"
                        [(ngModel)]='month'>
                  <option *ngFor='let m of months; let i = index; trackBy: trackByFn' [value]='m'>
                    {{ m }}
                  </option>
                </select>
              </c11n-select>
            </div>
            <div class='d-inline-block me-4 col-12 col-lg-3 col-md-3 c11n-grid-story__cell custom-container'>
              <c11n-select label='' hintText='' labelText='' class='hide-select-label-and-error'
                           (change)="getSelectedValue($event, 'confirmType')" [labelText]="confirmsContent.formFields.confirmationTypeLabel || 'Confirmation type'">
                <select c11nSelectInput id='select-confirmType-id' class='c11n-select__box__select'
                        [attr.aria-label]="confirmsContent.formFields.confirmationTypeAltText || 'select confirmation type'" [(ngModel)]='confirmType'>
                  <option *ngFor='let m of confirmationType; let i = index' [value]='m'>
                    {{ m }}
                  </option>
                </select>
              </c11n-select>
            </div>

          </div>
        </div>

        <c11n-spinner *ngIf='isLoaderIndicator' class='spinner-on-screen' size='medium' colorMode='on-light'
                      spinnerStatus='Loading...'>
        </c11n-spinner>

        <div class="for-scroll" #contentElement data-id='scrollable_table' (scroll)='onScroll()'>

          <table class='c11n-table c11n-table--small c11n-table--sticky-th-horizontal c11n-table--sticky-th-vertical' [class.compact-view]="isCompactView"
                 data-cy='recent-trans-table' data-vui-sticky-elements-parent='' id='confirms-table'>
            <thead confirmsStickyHeader>
            <tr class='c11n-table__tr'>
              <th scope='col' class='c11n-table__thead-th' [attr.aria-sort]='dateSortingState'
                  [ngClass]="[dateSortingState, dateSortingState !== 'none' ? 'c11n-table__thead-th--active-sort': '']">
                <button type='button' (click)="sortColumn('date')"
                        class='c11n-link c11n-link--secondary c11n-link--icon c11n-link--normal' title='Sort by date'
                        [attr.aria-label]="'Sorted ' + dateSortingState" style='width: 100%; text-align: left;'>
                    <span class='c11n-link__content'>
                      <span id='date_column'
                            class='c11n-link__text type-header'>{{confirmsContent.tableSection['dateColumnLabel']}}</span>
                      <svg viewBox='0 0 8 14' focusable='false' aria-hidden='true'>
                        <use xlink:href='#c11n-table-sort-arrow'></use>
                        <use xlink:href='#c11n-table-sort-arrow'></use>
                      </svg>
                    </span>
                </button>
                <div data-id='scroll_left' class='scroll-left hide-arrows-mobile' hidden (click)='scrollLeft()'>
                  <c11n-icon [name]="'caret-left'" [size]="'small'"></c11n-icon>
                </div>
              </th>

              <th scope='col' class='c11n-table__thead-th confirm-type-width'
                  [attr.aria-sort]='confirmTypeSortingState'
                  [ngClass]="[confirmTypeSortingState, confirmTypeSortingState !== 'none' ? 'c11n-table__thead-th--active-sort': '']">

                <button type='button' (click)="sortColumn('confirmationEvent')"
                        class='c11n-link c11n-link--secondary c11n-link--icon c11n-link--normal'
                        title='Sort by Confirmation Type' [attr.aria-label]="'Sorted ' + confirmTypeSortingState" style='width: 100%; text-align: left;'>
                    <span class='c11n-link__content'>
                      <span id='confirm_type'
                            class='c11n-link__text type-header account-header'>{{confirmsContent.tableSection['confirmationTypeColumnLabel']}}</span>
                      <svg viewBox='0 0 8 14' focusable='false' aria-hidden='true'>
                        <use xlink:href='#c11n-table-sort-arrow'></use>
                        <use xlink:href='#c11n-table-sort-arrow'></use>
                      </svg>
                    </span>
                </button>
              </th>
              <th scope='col' class='c11n-table__thead-th account-header confirm-description-style'
                  [attr.aria-sort]='descriptionSortingState'
                  [ngClass]="[descriptionSortingState, descriptionSortingState !== 'none' ? 'c11n-table__thead-th--active-sort': '']">

                <button type='button' (click)="sortColumn('confirmationDescription')"
                        class='c11n-link c11n-link--secondary c11n-link--icon c11n-link--normal'
                        title='Sort by confirmation description' [attr.aria-label]="'Sorted ' + descriptionSortingState" style='width: 100%; text-align: left;'>
                    <span class='c11n-link__content'>
                      <span id='description_column'
                            class='c11n-link__text type-header'>{{confirmsContent.tableSection['descriptionColumnLabel']}}</span>
                      <svg viewBox='0 0 8 14' focusable='false' aria-hidden='true'>
                        <use xlink:href='#c11n-table-sort-arrow'></use>
                        <use xlink:href='#c11n-table-sort-arrow'></use>
                      </svg>
                    </span>
                </button>
              </th>
              <th scope="col" class="c11n-table__thead-th c11n-table__thead-th--align-left">
                              <span id="view-download" class="view-download" title="view" role="text" aria-label="view">
                                {{confirmsContent.tableSection['viewLabel']}} </span>
              </th>
              <!--responsivedownload class is For Mobile view-->
              <th scope='col' class='c11n-table__thead-th c11n-table__thead-th--align-left'>
                  <span id='download' class='description-header'>
                    {{ confirmsContent.tableSection['viewDownloadColumnLabel'] }}
                  </span>
              </th>

              <ng-container *ngIf="environment.internal">

                <th scope="col" class="c11n-table__thead-th c11n-table__thead-th--align-left col-internal-type-confirm">
                    <span id="media-type" title="media-type" aria-label="frequency" role="document">
                      <div class="c11n-text-header-xs-bold" style="white-space: nowrap">{{ confirmsContent.tableSection['internalOnlyLabel'] || 'Internal only' }}</div>
                      <span style="white-space: nowrap" class="c11n-text-header-sm-bold">
                        {{ confirmsContent.tableSection['mediaTypeColumnLabel'] }}
                    </span>
                    </span>
                </th>

<th scope="col" class="c11n-table__thead-th c11n-table__thead-th--align-left col-internal-dark-green">
                  <span id="request-duplicate"
                        aria-label="request-duplicate" role="document" class="internal__only">
                    <div class="c11n-text-header-xs-bold" style="white-space: nowrap">{{ confirmsContent.tableSection['internalOnlyLabel'] || 'Internal only' }}</div>
                    <span class="c11n-text-header-sm-bold" style="white-space: nowrap">{{ confirmsContent.tableSection['duplicateColumnLabel'] || 'Duplicate' }}</span>
                  </span>
                </th>

                <th scope="col" *ngIf="isConfirmationStatusUpdate || isConfirmationStatusUpdateDelete" class="c11n-table__thead-th c11n-table__thead-th--align-left col-internal-dark-green">
                                <span id="status"  aria-label="status" role="document" class="internal__only">
                                  <div class="c11n-text-header-xs-bold">Internal only</div>
                                  <span class="c11n-text-header-sm-bold">Status</span>
                                </span>
                </th>
                <th scope="col" *ngIf="isConfirmationStatusUpdate || isConfirmationStatusUpdateDelete" class="c11n-table__thead-th col-internal-dark-green col-status-change"></th>

              </ng-container>

              <th class="sticky-right gradient-right">
                <div data-id="scroll_right" class="scroll-button scroll-right" (click)="scrollRight()">
                  <c11n-icon [name]="'caret-right'" [size]="'small'"></c11n-icon>
                </div>
              </th>
              <ng-container *ngIf="environment.internal">

              </ng-container>
            </tr>
            </thead>
            <tbody>
            <tr *ngIf='shouldShowErrorBannerForNoData'>
              <td [colSpan]='colSpan()'>
                <div class='c11n-banner c11n-banner--small c11n-banner--error'>
                  <div class='c11n-banner__leading-icon'>
                    <svg class='c11n-error-small error-icon-style' role='img' aria-hidden='false' focusable='true'>
                      <title>error</title>
                      <use xlink:href='#error-small'></use>
                    </svg>
                  </div>

                  <div class='c11n-banner__main'>
                    <div class='c11n-banner__content'>
                      <div class='c11n-banner__body'>
                        <div class='c11n-text-md--crop'>{{ contentBody }}</div>
                      </div>
                    </div>
                  </div>
                </div>
              </td>
            </tr>
            <tr *ngIf='shouldShowErrorBannerForApiFailure'>
              <td [colSpan]='4'>
                <div class='c11n-banner c11n-banner--small c11n-banner--error'>
                  <div class='c11n-banner__leading-icon'>
                    <svg class='c11n-error-small error-icon-style' role='img' aria-hidden='false' focusable='true'>
                      <title>error</title>
                      <use xlink:href='#error-small'></use>
                    </svg>
                  </div>

                  <div class='c11n-banner__main'>
                    <div class='c11n-banner__content'>
                      <div class='c11n-banner__body'>
                        <div class='c11n-text-md--crop'>{{ apiFailureErrorBody }}</div>
                      </div>
                    </div>
                  </div>
                </div>
              </td>
            </tr>
            <ng-container *ngFor='let confirmation of standardConfirmList; let i = index'>
              <tr class='c11n-table__tr' >
              <td [ngClass]="getHighLightCss(confirmation)"
                class='recent-transaction-type c11n-table__td c11n-table__td--align-left c11n-table__td c11n-table__td--align-left sticky-left'>
                {{ confirmation.endDate }}
              </td>

              <td [ngClass]="getHighLightCss(confirmation)" class='recent-transaction-type c11n-table__td c11n-table__td--align-left '>
                {{ confirmation.confirmationEvent }}
              </td>
              <td [ngClass]="getHighLightCss(confirmation)" class='recent-transaction-type c11n-table__td c11n-table__td--align-left'
                  [innerHTML]='confirmation.confirmationDescription'></td>
                <td *ngIf="showPdfData" [ngClass]="getHighLightCss(confirmation)"
                    class="recent-transaction-type c11n-table__td align-items-center c11n-table__td-align-center-icon">
                  <c11n-icon tabindex="0" style="display: inline-block;" size="medium" name="document"
                             class="responsive_pdf_icon c11n-icon icon-focus" title="View PDF" [attr.id]="'view-icon-' + i" focusable="true"
                             role="button"
                             attr.aria-label="View pdf statement generated on {{confirmation.endDate | date: 'longDate'}} with description {{confirmation.confirmationDescription}}"
                             (click)="downloadedpdf(confirmation.confirmationId, $event, confirmation)"
                             (keydown.space)="keyHandlerView($any ($event ) , confirmation.confirmationId, confirmation)"
                             (keydown.enter)="keyHandlerView($any ($event ), confirmation.confirmationId, confirmation)">
                  </c11n-icon>
                  <c11n-modal-dialog [headingText]="confirmsDesc" id="myCustomModal"
                                     style="width: 160vw; max-width: 160vw; padding: 0; border: none;">
                                <span c11n-modal-dialog-body style="display: block;">
                                  <div class="modal-actions">
                                    <c11n-icon [size]="'small'" [name]="'print'" class="responsive_pdf_icon c11n-icon icon-focus" title="Print PDF"
                                               tabindex="0" role="button" focusable="true" aria-label="Print current PDF document"
                                               (click)="printCurrentPdf()"
                                               (keydown.space)="keyHandlerPrint($any ($event))"
                                               (keydown.enter)="keyHandlerPrint($any ($event))">
                                    </c11n-icon>
                                  </div>
                                  <div *ngIf="isLoaderIndicator" class="loading-container">
                                    <c11n-spinner size="medium" variant="primary"></c11n-spinner>
                                    <p class="loading-text">Loading PDF…</p>
                                  </div>
                                  <div #pdfContainer class="pdf-container">
                                  </div>
                                </span>
                  </c11n-modal-dialog>
                </td>
              <td [ngClass]="getHighLightCss(confirmation)" class='recent-transaction-type c11n-table__td align-items-center c11n-table__td-align-center-icon'>
                <c11n-icon name='download' class='responsive_pdf_icon c11n-icon icon-focus' tabIndex='0'
                           style="display: inline-block; width: 30px;" size="medium"
                           title='Pdf download icon' id='download-icon-{{i}}' focusable="true" role="button"
                           (click)='downloadpdf(confirmation.confirmationId, $event)'
                           (keydown.space)='keyHandler($event, confirmation.confirmationId);'
                           (keydown.enter)='keyHandler($event, confirmation.confirmationId);'
                           attr.aria-label="Download a pdf {{confirmation.confirmationEvent}} generated on {{confirmation.endDate | date: 'longDate'}} with description {{confirmation.confirmationDescription}}"
                           role='button'>
                  <svg aria-hidden='true' focusable='false' class='c11n-download-small'>
                    <use xlink:href='#download-small'></use>
                  </svg>
                </c11n-icon>
              </td>

                <ng-container *ngIf="environment.internal">
                  <td class="recent-transaction-type c11n-table__td c11n-table__td--align-left sticky-left  col-internal-highlight-confirm">
                    {{confirmation.delieveryMethod  | titlecase }}
                  </td>


<td class="recent-transaction-type c11n-table__td c11n-table__td--align-left  col-internal-highlight">
                    <ng-container
                      *ngIf="confirmation.availabilityStatus === AVAILABILITY.ONLINE; else elseBlock">
                      <a role="button" tabindex="0" aria-label="Send statement" class="c11n-link send" c11n-link [fontWeight]="'bold'" [variant]="'secondary-reinforced'"  [colorMode]="'on-light'"
                         (click)="onSend(confirmation)" (keydown.space)="viewSendOnSpaceOrEnterKeyPress($event, confirmation);" (keydown.enter)="viewSendOnSpaceOrEnterKeyPress($event, confirmation);">{{ confirmsContent.sendLabel || 'Send' }}</a>
                    </ng-container>
                  </td>
                  <td *ngIf="isStatusColumnViewable(confirmation)" class="recent-transaction-type c11n-table__td c11n-table__td--align-left col-internal-highlight">
                    <ng-container *ngIf="!isStatusColumnDisabled(confirmation); else disabledDropDown">
                      <c11n-dropdown [hideLabel]="true"  [size]="'medium'" [variant]="'basic'"
                                     [menuData]="confirmation.statusListDropdown||defaultDropMenuData"
                                     (stateChange)="dropDownChangeEvent($event, confirmation)" [direction]="'below'"
                                     [activeItems]="getActiveItems(confirmation) "
                      ></c11n-dropdown>
                    </ng-container>

                    <ng-template #disabledDropDown>
                      <span>{{ isDeleteOrDeleStatus(confirmation) ? '—' : getActiveItems(confirmation) | titlecase }}</span>
                    </ng-template>
                  </td>
                  <td *ngIf="isStatusColumnViewable(confirmation)"
                      class="c11n-table__td c11n-table__td--align-center c11n-table__thead-th  c11n-table__td-align-center-icon  col-internal-highlight col-status-change">
<!--                    we need to change the size here-->
                    <ng-container *ngIf="borderOnSelect(confirmation)">
                      <c11n-icon size="small" name="success" style="display: inline-block; width: 16px; height: 16px;"
                                  title="modified">
                      </c11n-icon>
                    </ng-container>
                  </td>
                </ng-container>



            </tr>
            </ng-container>
            </tbody>
          </table>
        </div>
        <a class='c11n-link c11n-link--secondary show-more-link c11n-text-sm c11n-link--independent c11n-link--normal'
           id='show-more' tabIndex='0' (keydown.space)='keyHandlerShowMore($event);'
           (keydown.enter)='keyHandlerShowMore($event);' (click)='showMoreConfirms($event)' [hidden]='hideShowMore'>
          <span class='c11n-link__content'>{{ confirmsContent.showMoreLabel || 'Show more' }}</span>
        </a>
        <!-- </div> -->
        <div class="row mt-4 justify-content-end">
          <div class="col-12 col-sm-12 col-md-4 col-lg-3">
            <div class="change__status " *ngIf="storeSelectedConfirms.size > 0 &&
                       environment.internal &&
                       !shouldShowErrorBannerForNoData &&
                       (isConfirmationStatusUpdate || isConfirmationStatusUpdateDelete)">
              <c11n-internal-callout class="c11n-internal-callout" [variant]="'horizontal'" [headingLevel]="6">
                <c11n-button buttonType="button" size="small" variant="primary"
                             [attr.aria-label]="'Change status'" title="change status"
                             [labelText]="'Change status'"
                             (clickEvent)="reviewAndSubmit()"></c11n-button>
              </c11n-internal-callout>
            </div>
          </div>
        </div>

        <div class='bottom-paragraph-section mt-3' [innerHTML]='confirmsContent.notesAndDisclosures'></div>

        <div class='disclaimer mb-4' [innerHTML]='confirmsContent.disclaimer'></div>
      </div>
    </div>
  </div>
</ss-lib-page-layout>

<c11n-modal-dialog #chooseColumnModal [headingText]='confirmsContent.heading'>
  <span c11n-modal-dialog-body>
    <ng-container>
      <div class='row'>
        <div class='col-sm-10'>
          <c11n-button buttonType='button' size='small' [variant]="showConfirmType ? 'primary' : 'secondary'"
                       class='d-inline-block update-button modal-button'
                       [labelText]='confirmsContent.tableSection["confirmationTypeColumnLabel"] || ""' (clickEvent)='
              toggleAccountdownload(
                confirmsContent.tableSection["confirmationTypeColumnLabel"] || ""
              )
            ' c11nModalButtonPrimary></c11n-button>
        </div>
        <div class='col-sm-10 my-1'>
          <c11n-button buttonType='button' size='small' [variant]="showdescription ? 'primary' : 'secondary'"
                       class='d-inline-block update-button modal-button'
                       [labelText]='confirmsContent.tableSection["descriptionColumnLabel"] || ""' (clickEvent)='
              toggleAccountdownload(
                confirmsContent.tableSection["descriptionColumnLabel"] || ""
              )
            ' c11nModalButtonPrimary></c11n-button>
        </div>
        <div class='col-sm-10'>
          <c11n-button buttonType='button' size='small' [variant]="showpdf ? 'primary' : 'secondary'"
                       class='d-inline-block update-button modal-button'
                       [labelText]='confirmsContent.tableSection["viewDownloadColumnLabel"] || ""' (clickEvent)='
              toggleAccountdownload(
                confirmsContent.tableSection["viewDownloadColumnLabel"] || ""
              )
            ' c11nModalButtonPrimary>
          </c11n-button>
        </div>
      </div>
    </ng-container>
  </span>
</c11n-modal-dialog>


<c11n-modal-dialog #errorModal [headingText]='errorPdfDownload' class='error-modal'>
  <span c11n-modal-dialog-body>
    <ng-container>
      <div class='row'>
        <span>We apologize for any inconvenience. You'll need to try again later.</span>
        <c11n-button style='display: none;' c11nModalButtonPrimary></c11n-button>
      </div>
    </ng-container>
  </span>
</c11n-modal-dialog>


<ng-template #elseBlock>
  <span class="c11n-link__content">—</span>
</ng-template>
